import { createStore } from "vuex";

export default createStore({
  state: {
    user: null,
    selectedNorms: [],
  },
  getters: {},
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    updateSelectedNorms(state, normId) {
      if (state.selectedNorms.includes(normId)) {
        state.selectedNorms = state.selectedNorms.filter((id) => id !== normId);
      } else {
        state.selectedNorms.push(normId);
      }
    },
  },
  actions: {},
  modules: {},
});
